/**
 * Resuelve una ruta relativa a un asset anteponiendo PUBLIC_URL.
 */
export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname